import React, { useState, useEffect } from 'react'

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasAccepted = localStorage.getItem('almikial-cookies-accepted')
    if (!hasAccepted) {
      setShowBanner(true)
    }
  }, [])

  const acceptAllCookies = () => {
    localStorage.setItem('almikial-cookies-accepted', 'all')
    setShowBanner(false)
  }

  const rejectCookies = () => {
    localStorage.setItem('almikial-cookies-accepted', 'essential')
    setShowBanner(false)
  }

  const managePreferences = () => {
    // You can implement a preferences modal here
    localStorage.setItem('almikial-cookies-accepted', 'custom')
    setShowBanner(false)
  }

  if (!showBanner) return null

  return (
    <div style={{
      position: 'fixed',
      bottom: '0',
      left: '50%',
      transform: 'translateX(-50%)',
      width: 'calc(100% - 40px)',
      maxWidth: '1200px',
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      backdropFilter: 'blur(20px)',
      borderRadius: '25px 25px 0 0',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderBottom: 'none',
      boxShadow: '0 -8px 32px rgba(0, 0, 0, 0.3)',
      padding: '20px 30px',
      zIndex: 10000,
      animation: 'slideInUp 0.5s ease-out'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '20px',
        flexWrap: 'wrap'
      }}>
        {/* Cookie message */}
        <div style={{
          flex: '1',
          minWidth: '300px'
        }}>
          <p style={{
            margin: '0',
            color: 'white',
            fontSize: '14px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: '400',
            lineHeight: '1.5',
            textShadow: '0 1px 3px rgba(0, 0, 0, 0.5)'
          }}>
            This website uses cookies and other similar technologies to ensure you get the best experience on our website. Please review our{' '}
            <a href="#cookie-policy" style={{
              color: '#60A5FA',
              textDecoration: 'underline',
              fontWeight: '500'
            }}>
              cookie policy
            </a>
            {' '}and our{' '}
            <a href="#privacy-policy" style={{
              color: '#60A5FA',
              textDecoration: 'underline',
              fontWeight: '500'
            }}>
              data protection privacy notice
            </a>
            {' '}for more information on how the data that is collected is used.
          </p>
        </div>

        {/* Cookie buttons */}
        <div style={{
          display: 'flex',
          gap: '12px',
          alignItems: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={acceptAllCookies}
            style={{
              padding: '10px 20px',
              backgroundColor: 'rgba(255, 255, 255, 0.15)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '20px',
              color: 'white',
              fontSize: '13px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(10px)',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.25)'
              e.target.style.borderColor = 'rgba(255, 255, 255, 0.4)'
              e.target.style.transform = 'translateY(-1px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.15)'
              e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)'
              e.target.style.transform = 'translateY(0)'
            }}
          >
            ACCEPT ALL COOKIES
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
          </button>

          <button
            onClick={rejectCookies}
            style={{
              padding: '10px 20px',
              backgroundColor: 'transparent',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              borderRadius: '20px',
              color: 'rgba(255, 255, 255, 0.8)',
              fontSize: '13px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(10px)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'
              e.target.style.borderColor = 'rgba(255, 255, 255, 0.5)'
              e.target.style.color = 'white'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent'
              e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)'
              e.target.style.color = 'rgba(255, 255, 255, 0.8)'
            }}
          >
            REJECT ALL COOKIES (EXCEPT STRICTLY NECESSARY)
          </button>

          <button
            onClick={managePreferences}
            style={{
              padding: '10px 20px',
              backgroundColor: 'transparent',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              borderRadius: '20px',
              color: 'rgba(255, 255, 255, 0.8)',
              fontSize: '13px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(10px)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'
              e.target.style.borderColor = 'rgba(255, 255, 255, 0.5)'
              e.target.style.color = 'white'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent'
              e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)'
              e.target.style.color = 'rgba(255, 255, 255, 0.8)'
            }}
          >
            MANAGE COOKIE PREFERENCES
          </button>
        </div>
      </div>

      <style>{`
        @keyframes slideInUp {
          0% {
            opacity: 0;
            transform: translateX(-50%) translateY(100%);
          }
          100% {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .cookie-banner {
            width: calc(100% - 20px) !important;
            padding: 16px 20px !important;
            border-radius: 20px 20px 0 0 !important;
          }
          
          .cookie-buttons {
            flex-direction: column !important;
            gap: 8px !important;
            width: 100% !important;
          }
          
          .cookie-buttons button {
            width: 100% !important;
            justify-content: center !important;
            font-size: 12px !important;
            padding: 12px 16px !important;
          }
          
          .cookie-message {
            min-width: auto !important;
            margin-bottom: 16px !important;
          }
        }
      `}</style>
    </div>
  )
}

export default CookieConsent
